import { ApiCustomer } from '@vend/types'
import { store } from '../../factories/database/database'
import { useSyncManager } from '../../ng-compat/hooks'

export const useCustomerCodeSearch = () => {
  const syncManager = useSyncManager()
  const customersIndexDB = store('customers').index('byCustomerCode')

  return async (query: string): Promise<ApiCustomer | undefined> => {
    // Wait until customers are synced.
    await new Promise((resolve, reject) => {
      syncManager
        .whenCompleteEntityDataAvailable('customers')
        .then(() => resolve(null))
        .catch(err => reject(err))
    })

    // Search indexdb for the customer.
    const result = await new Promise<ApiCustomer[]>((resolve, reject) => {
      customersIndexDB
        .getAll(query)
        .then((v: ApiCustomer[]) => resolve(v))
        .catch(err => reject(err))
    })

    if (result.length > 0) {
      return result[0]
    }

    return undefined
  }
}
